import type AuthUser from '~/types/authUser';
import type { ModuleKey } from '~/types/companyModules';
import type { Rules } from '~/types/permissions';

export const moduleSubjects: Record<string, string[]> = {
  start: ['Periodicity', 'Local', 'Equipment', 'StandardEquipment', 'Supplier', 'Call', 'Maintenance', 'Start', 'DischargeType'],
  wa: ['WAMessage'],
  stock: ['Stock', 'StockIn', 'StockOut', 'StockRecord', 'StockAlert']
};

export function getModulesFromCompany(user: AuthUser): ModuleKey[] {
  return user.companyModules ?? [];
}

export function filterPermissionsByModules(rolePermissions: Rules[], activeModules: string[]): Rules[] {
  return rolePermissions.filter(([_action, subject]) => {
    if (subject === 'All') return true;

    // descobre qual módulo o subject pertence
    const entry = Object.entries(moduleSubjects).find(([_, subjects]) => subjects.includes(subject));

    if (!entry) return true;

    const [moduleKey] = entry;

    return activeModules.includes(moduleKey);
  });
}
